import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SearchContext } from '../../+state/service-locator/service-locator.models';

@Component({
  selector: 'drp-no-results-card',
  templateUrl: './no-results-card.component.html',
  styleUrls: ['./no-results-card.component.scss'],
  standalone: false
})
export class NoResultsCardComponent implements OnInit {
  @Input() searchContext: SearchContext;

  @Output() cancel = new EventEmitter<void>();

  @Output() noResults = new EventEmitter<void>();

  SEARCH_CONTEXT = SearchContext;
  // TODO: On Push change detection strategy
  constructor() {}

  ngOnInit() {
    this.noResults.emit();
  }
}
